import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { X } from "lucide-react";

export default function Memories() {
  const [events, setEvents] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [filter, setFilter] = useState("all");
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    api.get("/events/public").then((r) => setEvents(r.data)).catch(() => {});
    api.get("/gallery/public").then((r) => setGallery(r.data)).catch(() => {});
  }, []);

  const filtered = filter === "all" ? gallery : gallery.filter((g) => g.event_id === filter);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
      <div className="label">Memórias</div>
      <h1 className="font-display text-4xl sm:text-6xl font-black mt-2">Momentos que vivemos.</h1>
      <p className="text-slate-400 mt-3 max-w-xl">Fotos e vídeos de cada edição do Conexão Inefável. Reviva com a gente.</p>

      <div className="mt-10 flex gap-2 flex-wrap">
        <button data-testid="gallery-filter-all" onClick={() => setFilter("all")} className={`px-4 py-2 rounded-full text-xs font-bold tracking-widest transition-all ${filter === "all" ? "bg-blue-400 text-black" : "bg-slate-900/60 border border-blue-500/20 text-slate-300 hover:border-blue-400"}`}>TODAS</button>
        {events.map((e) => (
          <button key={e.id} data-testid={`gallery-filter-${e.edition_number}`} onClick={() => setFilter(e.id)}
                  className={`px-4 py-2 rounded-full text-xs font-bold tracking-widest transition-all ${filter === e.id ? "bg-blue-400 text-black" : "bg-slate-900/60 border border-blue-500/20 text-slate-300 hover:border-blue-400"}`}>
            EDIÇÃO #{String(e.edition_number).padStart(2, "0")}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="ci-card p-16 mt-10 text-center text-slate-400">Em breve, memórias inesquecíveis aqui.</div>
      ) : (
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {filtered.map((g) => (
            <button key={g.id} data-testid={`gallery-item-${g.id}`} onClick={() => setLightbox(g)} className="group aspect-square ci-card p-0 overflow-hidden">
              <img src={fileUrl(g.storage_path)} alt={g.caption} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
            </button>
          ))}
        </div>
      )}

      {lightbox && (
        <div data-testid="gallery-lightbox" className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-xl flex items-center justify-center p-4" onClick={() => setLightbox(null)}>
          <button className="absolute top-6 right-6 text-white p-2" onClick={() => setLightbox(null)}><X size={28} /></button>
          <img src={fileUrl(lightbox.storage_path)} alt={lightbox.caption} className="max-w-full max-h-full rounded-2xl" />
        </div>
      )}
    </div>
  );
}
